var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-tick"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick",
    clipPath: "url(#clip-tick)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18491",
    "data-name": "Path 18491",
    d: "M102.063,59.919h0a.5.5,0,0,1-.383-.174l-2.628-2.854a.517.517,0,0,1,.766-.7l2.262,2.454,6.264-6.247a.5.5,0,0,1,.731,0,.52.52,0,0,1,0,.731l-6.647,6.63A.474.474,0,0,1,102.063,59.919Z",
    transform: "translate(-94.545 -46.016)",
    fill: "#20bead",
    stroke: "#20bead",
    strokeWidth: 0.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.74a1c0e8.svg";
export { ForwardRef as ReactComponent };